export default __webpack_public_path__ + "static/media/01-Youtube-Red.d3bed64f.png";